import type { BackingStoreFactory, ParseNode, ParseNodeFactory } from '@microsoft/kiota-abstractions';
import { JsonParseNode, JsonParseNodeFactory } from '@microsoft/kiota-serialization-json';

export class EmptyJsonParseNodeFactory implements ParseNodeFactory {
  private readonly delegate: JsonParseNodeFactory;

  constructor(private readonly backingStoreFactory?: BackingStoreFactory) {
    this.delegate = new JsonParseNodeFactory(backingStoreFactory);
  }

  getValidContentType(): string {
    return this.delegate.getValidContentType();
  }

  getRootParseNode(contentType: string, content: ArrayBuffer): ParseNode {
    if (content.byteLength === 0) {
      return new JsonParseNode(undefined, this.backingStoreFactory);
    }

    return this.delegate.getRootParseNode(contentType, content);
  }
}
